module.exports = "/img/11.bd961a.webp";